import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchCurrentTournamentCalendar } from '@/lib/network';

const STALE_TIME_MS = 10 * 60 * 1000;
const GC_TIME_MS = 30 * 60 * 1000;

export type CurrentTournamentCalendar = {
  id: string;
  competition_name: string | null;
  season_label: string | null;
} | null;

/**
 * The active tournament calendar. Shared by every leaderboard surface so the
 * `['tournament-calendars', 'current']` query is defined once; React Query
 * dedupes the network call across all consumers.
 */
export const useCurrentTournamentCalendar = (): UseQueryResult<CurrentTournamentCalendar, Error> =>
  useQuery({
    queryKey: ['tournament-calendars', 'current'],
    queryFn: async () => {
      const res = await fetchCurrentTournamentCalendar();
      return res.data ?? null;
    },
    staleTime: STALE_TIME_MS,
    gcTime: GC_TIME_MS,
  });
